import { render, staticRenderFns } from "./PasswordResetBackgroundComponent.vue?vue&type=template&id=0d622a24&"
import script from "./PasswordResetBackgroundComponent.vue?vue&type=script&lang=js&"
export * from "./PasswordResetBackgroundComponent.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetBackgroundComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports